import ServionWordmark from '@/components/icons/servion/servion-wordmark';
import type { Appearance } from '@/hooks/use-appearance';
import { Link } from '@inertiajs/react';
import type { OpenWelcomeDialog, WelcomeAction } from './data';
import { WelcomeThemeToggle } from './welcome-theme-toggle';

type Props = {
    resolvedAppearance: 'light' | 'dark' | null;
    updateAppearance: (appearance: Appearance) => void;
    primary: WelcomeAction;
    access: WelcomeAction;
    showLogin: boolean;
    seekTo: (value: number) => void;
    openDialog: OpenWelcomeDialog;
};
export function WelcomeHeader({
    resolvedAppearance,
    updateAppearance,
    primary,
    access,
    showLogin,
    seekTo,
    openDialog,
}: Props) {
    return (
        <header className="site-header">
            <div className="header-inner">
                <Link
                    href="#inicio"
                    className="wordmark"
                    data-seek="0"
                    onClick={(event) => {
                        event.preventDefault();
                        seekTo(0);
                    }}
                    aria-label="Servion, início"
                >
                    <ServionWordmark
                        title="Servion"
                        width={190}
                        height={(190 * 193.84) / 1080}
                        primaryColor="#7EDCB1"
                        textColor="var(--srv-welcome-ink)"
                        textOffsetY={0}
                    />
                </Link>
                <nav className="main-nav" aria-label="Principal">
                    <button
                        type="button"
                        data-seek="1"
                        onClick={(event) => {
                            event.preventDefault();
                            seekTo(1);
                        }}
                    >
                        Produto
                    </button>
                    <button
                        type="button"
                        data-dialog="plans-dialog"
                        onClick={(event) =>
                            openDialog('plans-dialog', event.currentTarget)
                        }
                    >
                        Planos
                    </button>
                    <button
                        type="button"
                        data-dialog="faq-dialog"
                        onClick={(event) =>
                            openDialog('faq-dialog', event.currentTarget)
                        }
                    >
                        Dúvidas
                    </button>
                    <button
                        className="mobile-menu-toggle"
                        type="button"
                        data-dialog="menu-dialog"
                        onClick={(event) =>
                            openDialog('menu-dialog', event.currentTarget)
                        }
                        aria-label="Abrir menu"
                    >
                        Menu
                    </button>
                </nav>
                <div className="account-nav">
                    <WelcomeThemeToggle
                        resolved={resolvedAppearance}
                        onChange={updateAppearance}
                    />
                    {showLogin && (
                        <Link className="login-link" href={access.href}>
                            Entrar
                        </Link>
                    )}
                    <Link
                        className="button button-small"
                        href={primary.href}
                        data-app-link="register"
                    >
                        {primary.label}
                    </Link>
                </div>
            </div>
        </header>
    );
}
